import { getProductImages } from '@/services/api.service';

export default {
    namespaced: true,
    state: {
        productImages: [],
        fetchImageSize: 10,
        fetchImagePage: 0,
    },
    getters: {
        getProductImageById: (state) => (productId) => {
            try {
                if (!state.productImages.length) return '';
                const productImage = state.productImages.find(image => image.product_id === productId);
                return productImage || '';
            } catch (e) {
                return ''
            } 
        }
    },
    mutations: {
        setProductImages(state, productImages) {
            state.productImages = productImages;
        },
        setFetchImagePage(state, page) {
            state.fetchImagePage = page;
        }
    },
    actions: {
        async getProductImages({ commit, state, rootGetters }, productIds) {
            const data = {
                page: state.fetchImagePage,
                page_size: rootGetters['spreadsheet/products'].length + rootGetters['spreadsheet/combos'].length
            }
            if (productIds) {
                // product_id 需為陣列 就算是只有一個 id 也要包成陣列
                data.product_id = productIds;
            } else {
                data.product_id = [...rootGetters['spreadsheet/products'].map(product => product.id), ...rootGetters['spreadsheet/combos'].map(combo => combo.id)]
            }
            console.log('data', data);
            const res = await getProductImages(data);
            console.log('get product images', res.data.data);
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg
            }
            const productImages = res.data.data.product_image_list.filter(image => image);
            if (productImages.length) {
                commit('setProductImages', [...state.productImages, ...productImages]);
            }
        }
    },
}